export const SIZE_OPTIONS = {
  EXTRASMALL: "extraSmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  DISPLAY: "display"
};
export const baseURL = "//images.kiwi.com";